// import React, { useEffect } from "react";
// import Company from "./Company";
// import MainBanner from "./MainBanner";
// import NewwhychosesUS from "./NewwhychosesUS";
// import Ourclints from "./Ourclints";
// import Ourtestmonial from "./Ourtestmonial";
// import Ourpeople from "./Ourpeople";
// // import Bottomtotop from "./Bottomtotop";
// import Career from "./Career";
// import ContactBanner from "./ContactBanner";
// import Futuretrends from "./Futuretrends";
// import Ourcompanysection from './Ourcompanysection';
// import { useRef } from "react";
// import { useLocation } from "react-router-dom";
// import Advantage from './Advantage'
// const Home = () => {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
// const whyChooseUsRef = useRef(null);
// const contactRef = useRef(null);
// const location = useLocation();
// useEffect(() => {
//   if (location.state?.scrollTo === "whyChooseUs") {
//     setTimeout(() => {
//       whyChooseUsRef.current?.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }, 100);
//   }
// }, [location]);

// useEffect(() => {
//   if (location.state?.scrollTo === "ContactBanner") {
//     setTimeout(() => {
//       contactRef.current?.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }, 100);
//   }
// }, [location]);
  


//   return (
//     <div
//       style={{
//          backgroundImage:
//           "url('/image/3662a43d-artificial-intelligence.jpeg.optimal.jpeg')",
       
//         backgroundPosition: "center",
//         backgroundAttachment: "fixed",
//         backgroundRepeat: "no-repeat",
//         minHeight: "100vh",
//         width: "100%",
//       }}
//     >
//       <div style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}>
//         <MainBanner />
//         <Ourcompanysection/>
//         {/* <Company /> */}
//         <div ref={whyChooseUsRef}>
//         <NewwhychosesUS />
//         </div>
       
//         <Futuretrends />
//          <Advantage/>
//         {/* <Ourtestmonial /> */}
//         {/* <Ourpeople /> */}
//         {/* <Bigthinker /> */}
//         <Ourclints />
//         {/* <Ourtestmonial /> */}
//         {/* <Challenges/> */}
//         <Career />
//          <div ref={contactRef}>
//         <ContactBanner/>
//         </div>
//         {/* <Bottomtotop /> */}
//       </div>
//     </div>
//   );
// };

// export default Home;


import React, { useEffect } from "react";
import Company from "./Company";
import MainBanner from "./MainBanner";
import NewwhychosesUS from "./NewwhychosesUS";
import Ourclints from "./Ourclints";
import Ourtestmonial from "./Ourtestmonial";
import Ourpeople from "./Ourpeople";
// import Bottomtotop from "./Bottomtotop";
import Career from "./Career";
import ContactBanner from "./ContactBanner";
import Futuretrends from "./Futuretrends";
import Ourcompanysection from './Ourcompanysection';
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import Advantage from './Advantage'
const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
const whyChooseUsRef = useRef(null);
const contactRef = useRef(null);
const location = useLocation();
useEffect(() => {
  if (location.state?.scrollTo === "whyChooseUs") {
    setTimeout(() => {
      whyChooseUsRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }
}, [location]);

useEffect(() => {
  if (location.state?.scrollTo === "ContactBanner") {
    setTimeout(() => {
      contactRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }
}, [location]);
  


  return (
    <div
      style={{
        backgroundColor: "white",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}>
        <MainBanner />
        <Ourcompanysection/>
        {/* <Company /> */}
        <div ref={whyChooseUsRef}>
        <NewwhychosesUS />
        </div>
       
        <Futuretrends />
         <Advantage/>
        {/* <Ourtestmonial /> */}
        {/* <Ourpeople /> */}
        {/* <Bigthinker /> */}
        <Ourclints />
        {/* <Ourtestmonial /> */}
        {/* <Challenges/> */}
        <Career />
         <div ref={contactRef}>
        <ContactBanner/>
        </div>
        {/* <Bottomtotop /> */}
      </div>
    </div>
  );
};

export default Home;
